<template>
    <div class="flex justify-between">
        <div class="flex items-center gap-1">
            <label :for="'input-' + model.name">{{ t(`setting.${model.name}.title`) }}</label>
            <UTooltip
                v-if="shouldShowTooltip"
                :text="helpText"
                :delay-duration="0"
                :ui="{
                    content: 'h-fit overflow-visible',
                    text: 'whitespace-pre-line p-1',
                }"
            >
                <i class="i-ph-info inline-block" />
            </UTooltip>
        </div>
        <general-input
            :id="'input-' + model.name"
            v-model="innerValue"
            type="number"
            class="w-[200px]"
            :is-valid="isValid"
            @blur="onBlur"
        />
    </div>
</template>

<script setup lang="ts">
import {Setting} from '@/setting/setting.service'
import {computed, ref} from 'vue'
import GeneralInput from '@/components/GeneralInput.vue'
import {useI18n} from 'vue-i18n'
import {Maybe} from '@/types/Maybe'

const {t} = useI18n()

const model = defineModel<Setting<number>>({required: true})
const innerValue = ref<number | undefined>(model.value.value ?? model.value.default)

const helpText = computed(() => {
    return t(`setting.${model.value.name}.tooltip`)
})

const shouldShowTooltip = computed(
    () => helpText.value !== ''
)

const isWithinBounds = (value: number): boolean => {
    if (model.value.min && value < model.value.min) {
        return false
    }
    if (model.value.max && value > model.value.max) {
        return false
    }
    return true
}

const isValid = (value: Maybe<number>) => value && isWithinBounds(value) ? undefined : 'Ikke gyldig, må være mellom ' + model.value.min + ' og ' + model.value.max

const onBlur = () => {
    if (innerValue.value && isWithinBounds(innerValue.value)) {
        // If the value is out of bounds, set it to the default value
        model.value.value = innerValue.value
    } else {
        innerValue.value = model.value.value ?? model.value.default
    }
}

</script>

<style scoped>

</style>